import React from 'react';
import {
  Box,
  TextField,
  Button,
  Typography,
  Tooltip,
} from '@mui/material';
import { Science as ScienceIcon } from '@mui/icons-material';
import { ESMIFParams } from '@/types/colabfold';

// Import test parameters from the dedicated file
import { ESMIF_TEST_SEQUENCES } from './testParameters';

interface ESMIFFormProps {
  params: ESMIFParams;
  onChange: (params: ESMIFParams) => void;
}

const ESMIFForm: React.FC<ESMIFFormProps> = ({ params, onChange }) => {
  return (
    <Box>
      <Box mb={3}>
        <Typography variant="subtitle2" gutterBottom>
          Test Parameters
        </Typography>
        <Box display="flex" gap={1}>
          <Tooltip title="Load Test Parameters 1">
            <Button
              variant="outlined"
              size="small"
              startIcon={<ScienceIcon />}
              onClick={() => {
                onChange({
                  ...params,
                  input_pdb: ESMIF_TEST_SEQUENCES.test1.pdb,
                  ...ESMIF_TEST_SEQUENCES.test1.params
                });
              }}
            >
              Test 1
            </Button>
          </Tooltip>
          <Tooltip title="Load Test Parameters 2">
            <Button
              variant="outlined"
              size="small"
              startIcon={<ScienceIcon />}
              onClick={() => {
                onChange({
                  ...params,
                  input_pdb: ESMIF_TEST_SEQUENCES.test2.pdb,
                  ...ESMIF_TEST_SEQUENCES.test2.params
                });
              }}
            >
              Test 2
            </Button>
          </Tooltip>
        </Box>
      </Box>

      <TextField
        fullWidth
        label="PDB Structure"
        multiline
        rows={8}
        value={params.input_pdb}
        onChange={(e) => onChange({ ...params, input_pdb: e.target.value })}
        placeholder="Enter PDB structure data"
        required
        sx={{ mb: 3 }}
        helperText="Paste the content of a PDB file for inverse folding"
      />

      <TextField
        fullWidth
        label="Number of Designs"
        type="number"
        value={params.num_designs}
        onChange={(e) => onChange({ ...params, num_designs: parseInt(e.target.value) || 1 })}
        inputProps={{ min: 1, max: 50 }}
        sx={{ mb: 3 }}
      />

      <TextField
        fullWidth
        label="Temperature"
        type="number"
        value={params.temperature}
        onChange={(e) => onChange({ ...params, temperature: parseFloat(e.target.value) || 1.0 })}
        inputProps={{ min: 0.1, max: 2.0, step: 0.1 }}
        helperText="Range: 0.1 - 2.0 (Higher values = more diversity)"
        sx={{ mb: 3 }}
      />
    </Box>
  );
};

export default ESMIFForm; 